import step1_1 from "@/assets/integration-steps/tiktok/step_1_1.png";
import step1_2 from "@/assets/integration-steps/tiktok/step_1_2.png";
import step1_3 from "@/assets/integration-steps/tiktok/step_1_3.png";
import OpticksLink from "@/components/ui/OpticksLink/OpticksLink";
import OpticksNumberCircle from "@/components/ui/OpticksNumberCircle/OpticksNumberCircle";

interface Props {
  stepLabel?: string;
}

const TikTokIntegrationStep1 = ({ stepLabel }: Props) => (
  <div className="channels-integration-step tiktok-step-1">
    <div className="step-label-row">
      {stepLabel && <OpticksNumberCircle number={stepLabel} />}
      <h6>TikTok Pixel installation</h6>
    </div>
    <p>
      The TikTok Pixel is the piece of code that allows TikTok Ads to track
      events such as views, conversions, or add users to Audiences.
    </p>
    <p>
      Opticks uses an Audience to exclude invalid traffic, so the first step is
      to{" "}
      <b>
        make sure that both Opticks and your TikTok Pixel are properly installed
        in the page you want to protect.
      </b>
    </p>
    <p>
      You can see your current TikTok pixels by going at the following page
      inside the{" "}
      <OpticksLink
        href="https://ads.tiktok.com/business/"
        label="TikTok Ads platform"
      />
    </p>
    <img src={step1_1} alt="Screenshot of step 1.1 TikTok Integration" />
    <p>
      <b>
        If you use TikTok Ads you probably already have a pixel, which should
        appear there (2.a).
      </b>{" "}
    </p>
    <p>
      Otherwise,{" "}
      <b>click on (2.b) and then select a "Web" to create a pixel.</b> You will
      need to add it to your page, either using GTM or the code snippet
      directly.
    </p>
    <img src={step1_2} alt="Screenshot of step 1.2 TikTok Integration" />
    <img src={step1_3} alt="Screenshot of step 1.3 TikTok Integration" />
  </div>
);

export default TikTokIntegrationStep1;
